import { render, staticRenderFns } from "./TrusteesAmendment.vue?vue&type=template&id=fdea0be4"
import script from "./TrusteesAmendment.vue?vue&type=script&lang=js"
export * from "./TrusteesAmendment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports